import {KnowledgeBaseAction, KnowledgeBasePanelActionsEnum} from './knowledgeBasePanelActions';
import {KnowledgeBasePanelState} from './knowledgeBasePanelState';

export function knowledgeBasePanelReducer(
  state: KnowledgeBasePanelState,
  action: KnowledgeBaseAction,
): KnowledgeBasePanelState {
  switch (action.type) {
    case KnowledgeBasePanelActionsEnum.NAVIGATED: {
      return {
        ...state,
        parameters: action.payload.parameters,
      };
    }
    default: {
      return state;
    }
  }
}
